/* eslint-disable @typescript-eslint/no-unused-vars */
import { SearchOutlined, DownOutlined, CalendarOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Row, Checkbox, Spin } from 'antd';
import { optionLaptime } from 'constants/index';
import { Formik, FormikHelpers } from 'formik';
import { Form, Input, Select, SubmitButton } from 'formik-antd';
import { useScrollTop } from 'hooks';
import moment from 'moment';
import { getCPAPDetail } from 'pages/CpapDetail/thunk';
import { setMedical } from 'pages/Register/slices';
import { FC, useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { t_cpap_instructions } from 'types';
import {
  Text,
  BackToStepPrev,
  HeaderMini,
  HeaderTitle,
  Rectangle,
  MiniButton,
  Modal,
  ModalWarningLeavePage,
} from '../../components';
import { medicalInstitution, updateItem, workSpaceSelectors } from '../../containers/App/selectors';
import { RootState } from '../../store';
import { date } from '../Register/RegisterFirstStep/data';
import EditPatientModal from './EditPatientModal';
import { month } from './data';
import Wrap from './styles';
import { updateCPAP } from './thunk';

type CountPrevMonth = {
  month?: string;
  year?: string;
  date?: string;
};
const CpapEdit: FC = () => {
  useScrollTop();
  const { Option } = Select;
  const { TextArea } = Input;
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation<{ itemId: string }>();
  const downOutlined = <DownOutlined />;
  const { cpap_detail, loading } = useSelector(updateItem);
  const { currentWorkSpaceId, statusBill } = useSelector(workSpaceSelectors);
  const [pickDate, setPickDate] = useState<string | undefined>(cpap_detail.installation_date);
  const [fieldBirthDay, setFieldBirthDay] = useState<string>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [accessoriesState, setAccessoriesState] = useState<string[]>(cpap_detail.accessories || []);
  const [countPrevMonth, setCountPrevMonth] = useState<CountPrevMonth>({
    month: cpap_detail.last_month?.slice(4, 6) || undefined,
    year: cpap_detail.last_month?.slice(0, 4) || undefined,
  });
  const medicalInstitutionList = useSelector(medicalInstitution);
  const { medical, dataStoreFields } = useSelector((state: RootState) => state.register);

  const [accMask, setAccMask] = useState<string | undefined>(cpap_detail.acc_mask);
  const [accMaskSize, setAccMaskSize] = useState<string | undefined>(cpap_detail.acc_mask_size);
  const [machine, setMachine] = useState<string | undefined>(cpap_detail.machine);
  const [collection, setCollection] = useState<CountPrevMonth>({
    month: cpap_detail.collection_date?.slice(5, 7) || undefined,
    date: cpap_detail.collection_date?.slice(8, 10) || undefined,
  });
  const [spPrice, setSpPrice] = useState<any>(cpap_detail?.sp_price ? ['o_sp_price'] : null);
  const [checked, setChecked] = useState<boolean>(spPrice);
  const [exploitStop, setExploitStop] = useState<number>(Number(cpap_detail?.suspension_flg) || 0);
  const [errorAdd, setErrorAdd] = useState<string>('');

  const handleUpdateSuspen = () => {
    if (exploitStop === 1) {
      setExploitStop(0);
    } else {
      setExploitStop(1);
    }
  };
  useEffect(() => {
    if (location.state) {
      dispatch(getCPAPDetail(location.state.itemId));
    }
  }, [dispatch, location.state]);

  useEffect(() => {
    return () => {
      dispatch(setMedical({ medicalId: undefined, isUpdate: false }));
    };
  }, [dispatch]);

  const medicalInfo = useMemo(() => {
    if (medical.id) {
      return medicalInstitutionList.find((item) => item.i_id === medical.id);
    }
    return cpap_detail.lookup_items?.facility_name;
  }, [medicalInstitutionList, cpap_detail, medical]);

  const selectAccessories = useMemo(() => {
    return dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'accessories')[1].options || [];
  }, [dataStoreFields]);

  const selectAccMax = useMemo(() => {
    return dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'acc_mask')[1].options || [];
  }, [dataStoreFields]);

  const selectMachines = useMemo(() => {
    return dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'machine')[1].options || [];
  }, [dataStoreFields]);

  const selectAccMaxSize = useMemo(() => {
    return (
      dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'acc_mask_size')[1].options || []
    );
  }, [dataStoreFields]);

  const SelectCollectionDate = date(new Date().getDate(), collection.month ? +collection.month : 1);
  const optionMonths = month();

  useEffect(() => {
    function calculate_age(dob: any) {
      const diff_ms = Date.now() - dob.getTime();
      const age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - 1970);
    }
    if (cpap_detail.patient_birthday) {
      const year = cpap_detail.patient_birthday.slice(0, 4);
      const month = cpap_detail.patient_birthday.slice(5, 7);
      const date = cpap_detail.patient_birthday.slice(8, 10);

      const age = calculate_age(new Date(parseInt(year), parseInt(month), parseInt(date)));

      setFieldBirthDay(`${year}年${month}月${date}日（${age}歳）`);
    }
  }, [cpap_detail]);

  const [openModalPatient, setOpenModalPatient] = useState<boolean>(false);

  const valueMachine = selectMachines.find((s: any, key: any) => (s.display_id === machine ? s.value : ''));
  const valueAccessories = accessoriesState
    .map((acc) => {
      const dataFind = selectAccessories.find((s: any, key: any) => s.display_id === acc);
      return dataFind?.value || '';
    })
    .join();
  const valueAccMax = selectAccMax.find((s: any, key: any) => (s.display_id === accMask ? s.value : ''));
  const valueAccMaxSize = selectAccMaxSize.find((s: any, key: any) => (s.display_id === accMaskSize ? s.value : ''));
  const dataDate = collection.month && collection.date ? `${+collection.month}月${+collection.date}日` : '';
  const lastMonth =
    countPrevMonth.year && countPrevMonth.month ? `${countPrevMonth.year}年${+countPrevMonth.month}月` : '';
  const installation_date = pickDate ? moment(pickDate).format('YYYY年M月D日') : '';

  const handleSubmit = async (values: t_cpap_instructions, form: FormikHelpers<t_cpap_instructions>) => {
    const last_month =
      countPrevMonth.year && countPrevMonth.month ? `${countPrevMonth.year}${countPrevMonth.month}` : undefined;

    const currentYear = new Date().getFullYear();
    const collectionDate =
      collection.month && collection.date
        ? moment(`${currentYear}-${collection.month?.slice(0, 2)}-${collection.date?.slice(2)}`, 'YYYY-MM-DD').format(
            'YYYY-MM-DDThh:mm:ss',
          )
        : undefined;

    const acc =
      dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'acc_mask')[1].options || [];
    const acc_mask = acc.find((f: any) => f.display_id === accMask) || null;

    const machines =
      dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'machine')[1].options || [];
    const machineSubmit = machines.find((f: any) => f.display_id === machine) || null;

    const genders =
      dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'gender')[1].options || [];
    const valueGender = genders.find((f: any) => f.option_id === cpap_detail.gender);

    let setting: any = {
      sp_price: spPrice,
      suspension_flg: exploitStop,
      facility_name: medicalInfo?.i_id,
      in_charge_of_sales: medicalInfo?.in_charge_of_sales,
      clerk: values.clerk,
      transfer_history: values.transfer_history,
      lamp_time_max: values.lamp_time_max,
      lamp_time: values.lamp_time,
      pressure_max: values.pressure_max,
      pressure_min: values.pressure_min,
      accessories: accessoriesState,
      acc_hose_type: values.acc_hose_type,
      acc_humidifier_no: values.acc_humidifier_no,
      acc_other: values.acc_other,
      last_month: last_month,
      installation_date: pickDate || null,
      cpap_remark: values.cpap_remark,
      remark_for_output: values.remark_for_output,
      i_id: cpap_detail.i_id,
      a_id: cpap_detail.a_id,
      d_id: cpap_detail.d_id,
      machine_other: machineSubmit
        ? machineSubmit.display_id === 'o_other'
          ? values.machine_other
          : ''
        : values.machine_other,
      machine_no: values.machine_no,
      machine_epr_no: values.machine_epr_no,
      machine_dn_no: values.machine_dn_no,
      acc_mask_other: values.acc_mask_other,
      acc_mask_size_other: values.acc_mask_size_other,
      collection_date: collectionDate,
      zip_code: cpap_detail.zip_code,
      patient_id: cpap_detail.patient_id,
      patient_name: cpap_detail.patient_name,
      patient_name_kana: cpap_detail.patient_name_kana,
      patient_birthday: cpap_detail.patient_birthday || null,
      gender: cpap_detail.gender,
      address_1: cpap_detail.address_1,
      address_2: cpap_detail.address_2,
      mobile_phone_number: cpap_detail.mobile_phone_number,
      phone_number: cpap_detail.phone_number,
      facility_name_for_search: `${cpap_detail.gender} ${medicalInfo?.facility_name} ${medicalInfo?.facility_address1} ${medicalInfo?.facility_address2}`,
      cpap_setting_for_search: `${valueGender ? valueGender.value : ''} ${
        valueMachine ? valueMachine.value : cpap_detail.machine
      } ${valueAccessories ? valueAccessories.slice(4) : cpap_detail.accessories} ${
        valueAccMax ? valueAccMax.value : cpap_detail.acc_mask
      } ${valueAccMaxSize ? valueAccMaxSize.value : cpap_detail.acc_mask_size} ${
        spPrice ? '特別料金対象者' : ''
      } ${dataDate} ${lastMonth} ${installation_date}`,
      humidifier_machine_no: values.humidifier_machine_no,
      item_links: cpap_detail.item_links,
      sort_num: medical.isUpdated ? null : undefined,
    };
    if (machineSubmit) {
      setting = { ...setting, machine: machineSubmit.option_id };
    }
    if (acc_mask) {
      setting = { ...setting, acc_mask: acc_mask.option_id };
    }
    if (accMaskSize !== cpap_detail.acc_mask_size) {
      setting = { ...setting, acc_mask_size: accMaskSize };
    }

    const wpId = medical.id ? currentWorkSpaceId : '';
    const result: any = await dispatch(
      updateCPAP({
        workSpaceId: wpId,
        item: setting,
        statusBill: statusBill?.value === moment().subtract(1, 'M').format('YYYYMM'),
      }),
    );
    form.setSubmitting(false);
    if (result?.error) {
      setErrorAdd('エラーのため更新できませんでした');
    } else {
      history.push('/cpap/detail', { itemId: cpap_detail.i_id, omitWarningLeavePage: true });
    }
  };

  function check(e: any) {
    const index = accessoriesState.findIndex((f) => f === e.target.value);
    if (index > -1) {
      const newArr = [...accessoriesState];
      newArr.splice(index, 1);
      setAccessoriesState(newArr);
    } else {
      setAccessoriesState((oldState) => [...oldState, e.target.value]);
    }
  }

  const checkAccessories = (value: string): boolean => {
    return accessoriesState.findIndex((f: string) => f === value) > -1;
  };

  const closeModalPatient = () => {
    setOpenModalPatient(false);
  };

  const onChangeYear = (date: any, dateString: string) => {
    setCountPrevMonth({ ...countPrevMonth, year: dateString });
  };

  const onChangePickDate = (date: any, dateString: string) => {
    setPickDate(dateString ? moment(dateString, 'YYYY年MM月DD日').format('YYYY-MM-DDThh:mm:ss') : dateString);
  };

  useEffect(() => {
    if (spPrice === null) {
      setChecked(false);
    } else {
      setChecked(true);
    }
  }, [spPrice]);

  const handleUpdate = () => {
    if (!spPrice) {
      setSpPrice(['o_sp_price']);
      setChecked(true);
    } else {
      setSpPrice(null);
      setChecked(false);
    }
  };

  const onBack = () => {
    history.push('/cpap/detail', { itemId: cpap_detail.i_id });
  };

  const genders = dataStoreFields
    ? dataStoreFields?.find(([_key, value]: [string, any]) => value.display_id === 'gender')[1].options
    : [];
  const valueGender = genders.find((f: any) => f.option_id === cpap_detail.gender ?? '');

  if (!location.state) {
    return <Redirect to="/cpap" />;
  }

  return (
    <Wrap>
      <HeaderTitle title="CPAP指示書一覧・検索" icon={SearchOutlined} />
      <div className="backToScreenPrev">
        <BackToStepPrev backToPrev={onBack} />
      </div>
      <div className="cpap-body">
        {loading && (
          <div className="loading">
            <Spin size="large" />
          </div>
        )}
        <div className="headerMini">
          <HeaderMini text="CPAP指示書詳細" />
        </div>
        <Formik
          onSubmit={handleSubmit}
          initialValues={cpap_detail}
          render={({ setFieldValue }) => (
            <Form>
              <div className="section">
                <div className="box">
                  <Rectangle text="医療機関" decor="spaceBetween">
                    <MiniButton action={() => setOpenModal(true)} text="医療機関の変更" height="40px" />
                  </Rectangle>
                  <div className="content">
                    <Text
                      padding="20px 0"
                      textLeft="医療機関名"
                      textRight={medicalInfo?.facility_name}
                      fontLeft="standardBoldFont"
                      fontRight="standardBoldFont"
                      isBorder={false}
                      typeGrid={2}
                    />
                    <Text
                      padding="20px 0"
                      textLeft="所在地"
                      textRight={`${medicalInfo?.facility_zip ? `〒${medicalInfo?.facility_zip}` : ''}  ${
                        medicalInfo?.facility_address1 || ''
                      }  ${medicalInfo?.facility_address2 || ''}`}
                      fontLeft="standardBoldFont"
                      fontRight="standardFont"
                      isBorder={false}
                      typeGrid={2}
                    />
                    <Text
                      padding="20px 0px"
                      textLeft="TEL"
                      textRight={medicalInfo?.facility_tel}
                      fontLeft="standardBoldFont"
                      fontRight="standardFont"
                      isBorder={false}
                      typeGrid={2}
                    />
                    <Text
                      fontLeft="standardBoldFont"
                      isBorder={false}
                      padding="0"
                      textLeft="営業担当"
                      textRight={medicalInfo?.in_charge_of_sales}
                      fontRight="standardBoldFont"
                      typeGrid={2}
                    />
                    <Text fontLeft="standardBoldFont" isBorder={false} padding="0" textLeft="事務担当" typeGrid={2}>
                      <Col span={10}>
                        <Form.Item name="clerk">
                          <Input className="input" name="clerk" />
                        </Form.Item>
                      </Col>
                    </Text>
                    <Text fontLeft="standardBoldFont" isBorder={false} padding="0" textLeft="転院履歴" typeGrid={2}>
                      <Col span={10}>
                        <Form.Item name="transfer_history">
                          <TextArea name="transfer_history" rows={4} />
                        </Form.Item>
                      </Col>
                    </Text>
                  </div>
                </div>
                <div className="box">
                  <Rectangle text="療養者" decor="spaceBetween">
                    <MiniButton
                      text="患者情報の変更"
                      action={() =>
                        setOpenModalPatient((oldState) => {
                          return !oldState;
                        })
                      }
                      height="40px"
                    />
                  </Rectangle>
                  <div className="content">
                    <Text
                      padding="20px 0"
                      textLeft="お名前"
                      typeGrid={2}
                      isBorder={false}
                      textRight={
                        cpap_detail?.patient_name
                          ? `${cpap_detail.patient_name} ${
                              cpap_detail.patient_name_kana ? `(${cpap_detail.patient_name_kana})` : ''
                            }`
                          : ''
                      }
                      fontLeft="standardBoldFont"
                      fontRight="standardBoldFont"
                    />
                    <Text
                      padding="20px 0"
                      textLeft="患者ID"
                      typeGrid={2}
                      isBorder={false}
                      textRight={cpap_detail.patient_id}
                      fontLeft="standardBoldFont"
                      fontRight="standardFont"
                    />
                    <Text
                      padding="20px 0"
                      textLeft="性別"
                      typeGrid={2}
                      isBorder={false}
                      textRight={valueGender ? valueGender.value : ''}
                      fontLeft="standardBoldFont"
                      fontRight="standardFont"
                    />
                    <Text
                      padding="20px 0"
                      textLeft="生年月日"
                      typeGrid={2}
                      isBorder={false}
                      textRight={fieldBirthDay}
                      fontLeft="standardBoldFont"
                      fontRight="standardFont"
                    />
                    <Text
                      padding="20px 0"
                      textLeft="設置住所"
                      typeGrid={2}
                      isBorder={false}
                      textRight={`${cpap_detail.zip_code ? `〒${cpap_detail.zip_code}` : ''}  ${
                        cpap_detail.address_1 ? cpap_detail.address_1 : ''
                      }  ${cpap_detail.address_2 ? cpap_detail.address_2 : ''}`}
                      fontLeft="standardBoldFont"
                      fontRight="standardFont"
                    />
                    <Text
                      padding="20px 0"
                      textLeft="TEL"
                      typeGrid={2}
                      isBorder={false}
                      textRight={`${
                        cpap_detail?.phone_number ||
                        (cpap_detail?.mobile_phone_number ? `【携帯】${cpap_detail?.mobile_phone_number}` : '')
                      } ${
                        cpap_detail?.phone_number && cpap_detail?.mobile_phone_number
                          ? `/ 【携帯】 ${cpap_detail?.mobile_phone_number} `
                          : ''
                      } `}
                      fontLeft="standardBoldFont"
                      fontRight="standardFont"
                    />
                    <Row>
                      <Col span={4} className="standardBoldFont" style={{ marginTop: 5 }}>
                        特別料金対象者
                      </Col>
                      <Col span={20}>
                        <Form.Item name="sp_price">
                          <Checkbox value={spPrice} checked={checked} onChange={handleUpdate}>
                            対象
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="box">
                  <Rectangle text="設 定" />
                  <div className="content1">
                    <Text padding="0" textLeft="基本設定" isBorder={false} typeGrid={2} fontLeft="standardBoldFont">
                      <Col span={20} className="d-flex alignCenter">
                        <span className="mb-20 mr-5 standardFont">圧力</span>
                        <Form.Item name="pressure_min" className="mr-5">
                          <Input name="pressure_min" style={{ width: '60px' }} />
                        </Form.Item>
                        <span className="mb-20 standardFont mr-5">~</span>
                        <Form.Item name="pressure_max" className="mr-5">
                          <Input name="pressure_max" style={{ width: '60px' }} />
                        </Form.Item>
                        <span className="mb-20 standardFont mr-10">cmH2O</span>
                        <div className="mb-20 bar mr-10" />
                        <span className="mb-20 standardFont mr-5">ランプ時間</span>
                        <Form.Item name="lamp_time" className="mr-5">
                          <Select name="lamp_time" style={{ width: '70px' }}>
                            {optionLaptime.map((value) => (
                              <Select.Option value={value}>{value}</Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <span className="mb-20 standardFont mr-10">分</span>
                        <div className="mb-20 bar" />
                        <span className="mb-20 standardFont mr-5">最大ランプ時間</span>
                        <Form.Item name="lamp_time_max" className="mr-5">
                          <Select name="lamp_time_max" style={{ width: '70px' }}>
                            {optionLaptime.map((value) => (
                              <Select.Option value={value}>{value}</Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <span className="mb-20 standardFont">分</span>
                      </Col>
                    </Text>
                  </div>
                  <div className="content">
                    <Text
                      padding="0"
                      textLeft="基本設定"
                      isBorder={false}
                      typeGrid={2}
                      fontLeft="standardBoldFont d-flex alignCenter"
                    >
                      <Col span={20} className="nonError">
                        <Row className="bb-1" style={{ paddingBottom: '6px' }}>
                          <Col span={8}>
                            <Form.Item name="machine">
                              <Select
                                name="machine"
                                value={machine}
                                style={{ width: '100%' }}
                                onChange={(value) => {
                                  setMachine(value);
                                }}
                              >
                                {selectMachines.map((s: any, i: number) => (
                                  <Option key={i} value={s.display_id}>
                                    {s.value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                            <Form.Item name="machine_other" style={{ marginLeft: '6px' }}>
                              <Input disabled={machine !== 'o_other' && machine !== 'その他'} name="machine_other" />
                            </Form.Item>
                          </Col>
                          <Col span={2} className="d-flex alignCenter" style={{ justifyContent: 'center' }}>
                            <span>機番</span>
                          </Col>
                          <Col span={10}>
                            <Form.Item name="machine_no">
                              <Input name="machine_no" />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row className="bb-1">
                          <Col span={2} className="d-flex alignCenter">
                            <span>EPR</span>
                          </Col>
                          <Col span={4}>
                            <Form.Item name="machine_epr_no">
                              <Input name="machine_epr_no" maxLength={1} />
                            </Form.Item>
                          </Col>
                          <Col span={2} className="d-flex alignCenter" style={{ justifyContent: 'center' }}>
                            <span>DN/キー</span>
                          </Col>
                          <Col span={4}>
                            <Form.Item name="machine_dn_no">
                              <Input name="machine_dn_no" maxLength={4} />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Text>
                  </div>
                  <div className="content">
                    <Text
                      padding="0"
                      textLeft="付属品"
                      isBorder={false}
                      typeGrid={2}
                      fontLeft="standardBoldFont d-flex alignCenter"
                    >
                      <Col span={20} className="nonError">
                        <Row className="bb">
                          <Col span={4} className="itemCenter">
                            <span>{selectAccessories[0].value}</span>
                          </Col>
                          <Col span={2} className="d-flex alignCenter itemCenter">
                            <span>種類</span>
                          </Col>
                          <Col span={4}>
                            <Select
                              name="acc_mask"
                              className="acc_mask"
                              value={accMask}
                              style={{ width: '100%' }}
                              onChange={(e) => setAccMask(e)}
                            >
                              {selectAccMax.map((s: any, i: number) => (
                                <Option key={i} value={s.display_id}>
                                  {s.value}
                                </Option>
                              ))}
                            </Select>
                          </Col>
                          <Col span={3} style={{ marginLeft: '6px' }}>
                            <Form.Item className="mb-0" name="acc_mask_other">
                              <Input disabled={accMask !== 'o_other' && accMask !== 'その他'} name="acc_mask_other" />
                            </Form.Item>
                          </Col>
                          <Col span={2} className="d-flex alignCenter itemCenter" style={{ marginLeft: '6px' }}>
                            <span>サイズ</span>
                          </Col>
                          <Col span={4}>
                            <Select
                              name="acc_mask_size"
                              className="acc_mask_size"
                              value={accMaskSize}
                              style={{ width: '100%' }}
                              onChange={(value) => setAccMaskSize(value)}
                            >
                              {selectAccMaxSize.map((s: any, i: number) => (
                                <Option key={i} value={s.display_id}>
                                  {s.value}
                                </Option>
                              ))}
                            </Select>
                          </Col>
                          <Col span={3} style={{ marginLeft: '6px' }}>
                            <Form.Item className="mb-0" name="acc_mask_size_other">
                              <Input
                                disabled={accMaskSize !== 'o_size_other' && accMaskSize !== 'その他'}
                                name="acc_mask_size_other"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row className="bb-1">
                          <Col span={4} className="itemCenter">
                            <Checkbox
                              checked={checkAccessories(selectAccessories[1].display_id)}
                              onChange={check}
                              value={selectAccessories[1].display_id}
                            >
                              {selectAccessories[1].value}
                            </Checkbox>
                          </Col>
                          <Col span={3} className="alignCenter">
                            <span className="standardBoldFont">加湿器機番</span>
                          </Col>
                          <Col span={4}>
                            <Form.Item className="mb-0" name="humidifier_machine_no">
                              <Input
                                disabled={!checkAccessories(selectAccessories[1].display_id)}
                                name="humidifier_machine_no"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={4} style={{ marginLeft: 15 }} className="itemCenter">
                            <Checkbox
                              checked={checkAccessories(selectAccessories[2].display_id)}
                              onChange={check}
                              value={selectAccessories[2].display_id}
                            >
                              {selectAccessories[2].value}
                            </Checkbox>
                          </Col>
                        </Row>
                      </Col>
                    </Text>
                  </div>
                  <Row gutter={[16, 0]}>
                    <Col span={12}>
                      <div className="content">
                        <Row>
                          <Col span={11} md={8} xs={5} className="standardBoldFont  alignCenter">
                            次回定期送付月
                          </Col>
                          <Col span={13} md={16} xs={19}>
                            <div className="d-flex alignCenter">
                              <Form.Item name="year" className="mb-0">
                                <DatePicker
                                  value={countPrevMonth.year ? moment(countPrevMonth.year) : undefined}
                                  style={{ width: '100%' }}
                                  placeholder=""
                                  suffixIcon={downOutlined}
                                  onChange={onChangeYear}
                                  picker="year"
                                />
                              </Form.Item>
                              <p className="standardFont mb-0">年</p>
                              <Form.Item className="mb-0" name="month" style={{ width: '25%' }}>
                                <Select
                                  style={{ width: '5em' }}
                                  name="coutPreMonth"
                                  value={countPrevMonth.month}
                                  onChange={(date) => {
                                    setCountPrevMonth((oldState) => ({ ...oldState, month: date }));
                                  }}
                                  options={optionMonths}
                                />
                              </Form.Item>
                              <p className="standardFont mb-0">月</p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="content">
                        <Row>
                          <Col span={11} md={8} xs={5} className="standardBoldFont  alignCenter">
                            回収日
                          </Col>
                          <Col span={13} md={16} xs={19}>
                            <div className="d-flex alignCenter">
                              <Form.Item name="collect_month" className="mb-0">
                                <Select
                                  style={{ width: '5em' }}
                                  name="collect_month"
                                  value={collection.month}
                                  onChange={(date: string | number) => {
                                    setCollection((oldState) => ({ ...oldState, month: date.toString() }));
                                  }}
                                  options={optionMonths}
                                />
                              </Form.Item>
                              <p className="standardFont mb-0">月</p>
                              <Form.Item className="mb-0" name="collect_date" style={{ width: '25%' }}>
                                <Select
                                  name="collect_date"
                                  value={collection.date}
                                  options={SelectCollectionDate}
                                  onChange={(value) => setCollection((oldState) => ({ ...oldState, date: value }))}
                                />
                              </Form.Item>
                              <p className="standardFont mb-0">日</p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <div className="content">
                    <Text fontLeft="standardBoldFont" typeGrid={2} padding="0" textLeft="設置日" isBorder={false}>
                      <Col span={20}>
                        <div className="d-flex alignCenter">
                          <span className="standardFont m-5px">設置日</span>
                          <Form.Item className="mb-0" name="month">
                            <DatePicker
                              value={pickDate ? moment(pickDate) : undefined}
                              placeholder=""
                              format="YYYY年MM月DD日"
                              suffixIcon={<CalendarOutlined />}
                              onChange={onChangePickDate}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Text>
                  </div>
                  <div className="content">
                    <Text padding="0" textLeft="備考" fontLeft="standardBoldFont" typeGrid={2} isBorder={false}>
                      <Col span={20}>
                        <Form.Item name="cpap_remark" className="mb-0">
                          <TextArea name="cpap_remark" rows={6} />
                        </Form.Item>
                      </Col>
                    </Text>
                  </div>
                  <div className="content">
                    <Text
                      padding="0"
                      textLeft="受診明細用備考"
                      fontLeft="standardBoldFont"
                      typeGrid={2}
                      isBorder={false}
                    >
                      <Col span={20}>
                        <Form.Item name="remark_for_output" className="mb-0">
                          <Input name="remark_for_output" size={'large'} />
                        </Form.Item>
                      </Col>
                    </Text>
                  </div>
                  <div className="content">
                    <Text padding="0" textLeft="利用停止" fontLeft="standardBoldFont" typeGrid={2} isBorder={false}>
                      <Col span={20}>
                        <Form.Item name="suspension_flg" className="mb-0">
                          <Checkbox onChange={handleUpdateSuspen} value={exploitStop} checked={exploitStop === 1}>
                            利用停止
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Text>
                  </div>
                  <div className="submit">
                    <div className="title">
                      <p className="standardBoldFont mb-0">以上の内容で更新してよろしいですか。</p>
                    </div>
                    {errorAdd && <div className="errors">{errorAdd}</div>}
                    <div className="alignCenter">
                      <Button onClick={onBack} className="back">
                        戻る
                      </Button>
                      <SubmitButton className="btnDefault btn">更新する</SubmitButton>
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                onChangeSearch={setFieldValue}
                open={openModal}
                keySelected={medicalInfo?.i_id}
                onVisible={() => setOpenModal((oldState) => !oldState)}
                type={1}
              />
            </Form>
          )}
        />
        <EditPatientModal data={cpap_detail} visible={openModalPatient} onCanCel={closeModalPatient} />
        <ModalWarningLeavePage />
      </div>
    </Wrap>
  );
};

export default CpapEdit;
